/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const PAGE_INITIALIZATION_START = 'MFE/CHECKOUT/PAGE/INITIALIZATION/START';
export const PAGE_INITIALIZATION_COMPLETED = 'MFE/CHECKOUT/PAGE/INITIALIZATION/COMPLETED';
